import React, { useState } from "react";

// Hooks
import { useDispatch } from "react-redux";

// Actions
import { updateWebhookStatus } from "~/redux/actions/webhooks-actions";
import { success, failure } from "~/redux/actions/snackbar-actions";

// Utils
import { MESSAGES } from "~/utils/message";

// Mui Components
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Box, CircularProgress } from "@mui/material";

// Icons
import { ModalCrossCIcon, DisabedCIcon } from "~/assets/images";

// Styles
import "./styles.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ActionModal = (props) => {
  const { openModal, handleCloseModal, selectedWebhook } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setLoading(true);
      let payload = {
        id: selectedWebhook?.id,
        status: selectedWebhook?.status === "Disabled" ? "Enabled" : "Disabled",
      };
      const response = await dispatch(updateWebhookStatus(payload));
      dispatch(success(response.data.message));
      handleCloseModal();
    } catch (error) {
      dispatch(failure(response.data.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <BootstrapDialog
      onClose={handleCloseModal}
      aria-labelledby="customized-dialog-title"
      open={openModal}
      className="disableModalWrapper"
    >
      <IconButton
        aria-label="close"
        onClick={handleCloseModal}
        sx={{
          position: "absolute",
          right: 5,
          top: 5,
          padding: 0,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <ModalCrossCIcon />
      </IconButton>
      <DialogContent dividers className="webhookModalContent">
        <img height={70} src={DisabedCIcon} alt="disabled" />
        <Box className="deleteHeadings">
          <Typography gutterBottom variant="h4">
            {selectedWebhook?.status === "Disabled"
              ? MESSAGES.SETTINGS.WEBHOOKS.STATUS.ENABLE_TITLE
              : MESSAGES.SETTINGS.WEBHOOKS.STATUS.DISABLE_TITLE}
          </Typography>
          <Typography gutterBottom>
            {selectedWebhook?.status === "Disabled"
              ? MESSAGES.SETTINGS.WEBHOOKS.STATUS.ENABLE_HEADING
              : MESSAGES.SETTINGS.WEBHOOKS.STATUS.DISABLE_HEADING}
          </Typography>
          <Typography className="footerText">
            {selectedWebhook?.status === "Disabled"
              ? MESSAGES.SETTINGS.WEBHOOKS.STATUS.ENABLE_DESCRIPTION
              : MESSAGES.SETTINGS.WEBHOOKS.STATUS.DISABLE_DESCRIPTION}
          </Typography>
        </Box>
        <Box className="webhookactionModalBtns">
          <Button onClick={handleCloseModal}>
            {MESSAGES.SETTINGS.WEBHOOKS.STATUS.CANCEL_BUTTON}
          </Button>
          <Button onClick={onSubmit}>
            {loading ? (
              <CircularProgress
                sx={{
                  color: "white",
                  width: "25px !important",
                  height: "25px !important",
                }}
              />
            ) : (
              MESSAGES.SETTINGS.WEBHOOKS.STATUS.SUBMIT_BUTTON
            )}
          </Button>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ActionModal;
